import {AddSchema} from "mobx-graphlink";
import {GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";

export class EngineConfig_JourneyTraining {
	constructor(initialData: Partial<EngineConfig_JourneyTraining>) { Object.assign(this, initialData); }

	enabled: boolean;

	entityTags: string[];
	entityMinCount: number;
	seeds_basePerEntity: number;
	seeds_addFromDreams: boolean;

	voiceSoundTag: string;
	volumeMultiplier: number;
	prefixText: string;
	postfixText: string;
}
AddSchema("EngineConfig_JourneyTraining", {
	properties: {
		enabled: {type: "boolean"},

		entityTags: {items: {type: "string"}},
		entityMinCount: {type: "number"},
		seeds_basePerEntity: {type: "number"},
		seeds_addFromDreams: {type: "boolean"},

		voiceSoundTag: {type: "string"},
		volumeMultiplier: {type: "number"},
		prefixText: {type: "string"},
		postfixText: {type: "string"},
	},
});